import React from 'react';

const ChildSafety = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-orange-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Child Safety Standards</h1>
        <p className="text-gray-500 mb-2">Standards against Child Sexual Abuse and Exploitation (CSAE)</p>
        <p className="text-gray-500 mb-8">Last updated: June 30, 2026</p>

        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Our Commitment</h2>
            <p>
              HappyBook is a community built around positive, motivational content. We have a
              <strong> zero-tolerance policy</strong> toward child sexual abuse and exploitation (CSAE)
              and child sexual abuse material (CSAM). Any content, conduct, or account that exploits,
              endangers, or sexualizes minors is strictly prohibited and will be removed, and the
              responsible account will be permanently banned and reported to the appropriate authorities.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Prohibited Content & Conduct</h2>
            <p>The following are strictly forbidden on HappyBook:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Any child sexual abuse material (CSAM) or sexualized depictions of minors, real or computer-generated.</li>
              <li>Grooming, enticement, or solicitation of a minor for sexual purposes.</li>
              <li>Sextortion, or sharing/threatening to share intimate imagery of a minor.</li>
              <li>Trafficking, advertising, or facilitating the exploitation of minors.</li>
              <li>Any content that endangers a child's safety or well-being.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. How We Prevent Abuse</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Positive-only design:</strong> Content is moderated to keep the platform positive and motivational; sexual content is not permitted at all.</li>
              <li><strong>Automated moderation:</strong> Posts are screened by automated systems that block prohibited and harmful content.</li>
              <li><strong>Human review:</strong> Reported content is reviewed by our team for swift action.</li>
              <li><strong>Minimum age:</strong> HappyBook is not intended for users under 13 (or the minimum digital-consent age in your country).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Reporting Child Safety Concerns</h2>
            <p>
              Users can report any post, comment, message, or account that may violate these standards
              <strong> directly in the app</strong> using the "Report" option available on content and profiles.
              Reports relating to child safety are prioritized and reviewed promptly.
            </p>
            <p className="mt-2">
              You can also report concerns directly to us by email at
              <strong> tomaceo1983@gmail.com</strong>. If you believe a child is in immediate danger,
              contact your local law enforcement first.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. How We Respond</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>We remove violating content as quickly as possible.</li>
              <li>We permanently ban accounts involved in CSAE/CSAM.</li>
              <li>We preserve relevant information as required by law.</li>
              <li>We report apparent CSAM to the National Center for Missing &amp; Exploited Children (NCMEC) and/or the relevant regional and national authorities, in accordance with applicable law.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Legal Compliance</h2>
            <p>
              HappyBook complies with all applicable child-safety laws and cooperates with law
              enforcement and child-protection organizations. We comply with reporting obligations to
              regional and national authorities regarding child sexual abuse and exploitation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Designated Point of Contact</h2>
            <p>
              For questions about our child-safety practices or CSAM-prevention compliance, contact our
              designated point of contact:
            </p>
            <ul className="list-none mt-2 space-y-1">
              <li><strong>Email:</strong> tomaceo1983@gmail.com</li>
            </ul>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-center text-gray-500 text-sm">
            © 2026 HappyBook. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChildSafety;
